import axios from 'axios';
import { StringFormatter } from './StringFormatter';
import { Aesdecryption, Aesencryption } from '../Aes/Aes';

let cancelTokenSource = null;
let cachedApiUrl = null;

const getApiUrl = async () => {
  if (cachedApiUrl) return cachedApiUrl;
  const resp = await fetch('/apiinfo.json');
  const data = await resp.json();
  cachedApiUrl = data.apipathurl;
  return cachedApiUrl;
};

const Hexapi2 = (props) => new Promise(async (resolve, reject) => {
  if (cancelTokenSource) {
    cancelTokenSource.cancel('Request canceled due to new request.');
  }
  cancelTokenSource = axios.CancelToken.source();

  try {
    const apiUrl = await getApiUrl();
    const formattedQueryString = StringFormatter(props.query, props.queryArr);
    console.log(formattedQueryString);

    const fd = new FormData();
    fd.append(Aesencryption('Query'), Aesencryption(formattedQueryString));

    if (props.file !== undefined) {
      fd.append(Aesencryption('file'), props.file);
    }

    const resp = await axios({
      mode: 'cors',
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      url: `${apiUrl}fetchrsdataV3.php`,
      data: fd,
      cancelToken: cancelTokenSource.token,
    });

    const decrypted = Aesdecryption(resp.data);
    const parsed = JSON.parse(decrypted);
    if (parsed) {
      resolve(parsed);
    } else {
      reject('No valid response received');
    }
  } catch (err) {
    if (axios.isCancel(err)) {
      console.log('Request canceled:', err.message);
    } else {
      console.error(`Axios error in query: ${props.query}`, err);
      reject(err);
    }
  }
});

export default Hexapi2;